import { currentUser } from "./user";
import { userUpdate } from "./userUpdate";
import { userPasswordUpdate } from "./userPasswordUpdate";
import { userDisable } from "./userDisable";
import { userEnable } from "./userEnable";
import { userAdminUpdate } from "./userAdminUpdate";
import { userAdminPasswordUpdate } from "./userAdminPasswordUpdate";
import { createReferral } from "./createReferral";
import { userUnicoApprove } from "./userUnicoApproval";
import { getReferral } from "./getReferral";
import { userPin } from "./userPin";
import { userAdminPinUpdate } from "./userAdminPinUpdate";
import { userChangRole } from "./userChangeRole";
import { getUsersByRole } from "./getUsersByRole";
import { updateCpf } from "./updateCpf";
import { createSeller } from "./createSeller";

export const usersService = {
  currentUser,
  userUpdate,
  userDisable,
  userEnable,
  userPasswordUpdate,
  userAdminUpdate,
  userAdminPasswordUpdate,
  createReferral,
  userUnicoApprove,
  getReferral,
  userPin,
  userAdminPinUpdate,
  userChangRole,
  getUsersByRole,
  updateCpf,
  createSeller,
};
